export class ReplicatedObject {
    constructor(className, configKeys, writer, getMappedKey, view) {
        this.__data = null;
        this.__viewData = null;
        this.className = className;
        this.writer = writer;
        this.view = view !== null && view !== void 0 ? view : ((data) => data);
        this.configKeys = configKeys;
        this.getMappedKey = getMappedKey;
    }
}
export function unwrapConfigKey(input) {
    if ('required' in input) {
        return input.required;
    }
    return input.optional;
}
//# sourceMappingURL=ReplicatedObject.js.map